export const SECTIONS: Map<string, any> = new Map([
  [
    "sectionNavigation",
    (): Promise<unknown> =>
      import("../shared/components/section-navigation/section-navigation.component").then(
        (m) => m.SectionNavigationComponent,
      ),
  ],
  [
    "sectionFooter",
    (): Promise<unknown> =>
      import("../shared/components/footer/footer.component").then(
        (m) => m.FooterComponent,
      ),
  ],

  [
    "sectionHero",
    (): Promise<unknown> =>
      import("../shared/components/hero-section/hero-section.component").then(
        (m) => m.HeroSectionComponent,
      ),
  ],

  [
    "sectionGift",
    (): Promise<unknown> =>
      import("../shared/components/section-gift/section-gift.component").then(
        (m) => m.SectionGiftComponent,
      ),
  ],
  [
    "sectionText",
    (): Promise<unknown> =>
      import("../shared/components/section-text/section-text.component").then(
        (m) => m.SectionTextComponent,
      ),
  ],
  [
    "sectionQuote",
    (): Promise<unknown> =>
      import("../shared/components/section-quote/section-quote.component").then(
        (m) => m.SectionQuoteComponent,
      ),
  ],
  [
    "sectionEntryExperience",
    (): Promise<unknown> =>
      import("../shared/components/section-entry-experience/section-entry-experience.component").then(
        (m) => m.SectionEntryExperienceComponent,
      ),
  ],
  [
    "sectionProgram",
    (): Promise<unknown> =>
      import("../shared/components/section-program/section-program.component").then(
        (m) => m.SectionProgramComponent,
      ),
  ],
  [
    "sectionMembership",
    (): Promise<unknown> =>
      import("../shared/components/section-membership/section-membership.component").then(
        (m) => m.SectionMembershipComponent,
      ),
  ],
  [
    "sectionTestimonials",
    (): Promise<unknown> =>
      import("../shared/components/section-testimonials/section-testimonials.component").then(
        (m) => m.SectionTestimonialsComponent,
      ),
  ],

  [
    "richText",
    (): Promise<unknown> =>
      import("../shared/components/rich-text/rich-text-content.component").then(
        (m) => m.RichTextComponent,
      ),
  ],
]);
